import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import SunEditor from "suneditor-react";
import ManagePhotoPage from "../../pages/gallery/photo";
import ManageVideoPage from "../../pages/gallery/video";
import ManageDocumentPage from "../../pages/gallery/document";
import "suneditor/dist/css/suneditor.min.css";

const HtmlEditor = ({ onChange, ...props }) => {
	const [showPhotoMaldal, setShowPhotoModal] = useState(false);
	const [showVideoMaldal, setShowVideoModal] = useState(false);
	const [showDocumentMaldal, setShowDocumentModal] = useState(false);

	return (
		<div>
			<div>
				<Button
					type="primary"
					style={{ marginTop: 5, marginBottom: 5, marginRight: 5 }}
					onClick={() => setShowPhotoModal(true)}	
				>
					<i className="feather icon-image" style={{ marginRight: 5 }} /> แกลอรี่ภาพ
				</Button>
				<Button
					type="primary"
					style={{ marginTop: 5, marginBottom: 5, marginRight: 5 }}
					onClick={() => setShowVideoModal(true)}	
				>
					<i className="feather icon-film" style={{ marginRight: 5 }} />แกลอรี่วิดีโอ
				</Button>
				<Button
					type="primary"
					style={{ marginTop: 5, marginBottom: 5, marginRight: 5 }}
					onClick={() => setShowDocumentModal(true)}		
				>
					<i className="feather icon-file" style={{ marginRight: 5 }} /> แกลอรี่เอกสาร
				</Button>
			</div>
			<SunEditor
				{...props}
				setOptions={{
					height: 250,
					imageFileInput: false,
					buttonList: [
						['undo', 'redo'],
						['font', 'fontSize', 'formatBlock'],
						['paragraphStyle', 'blockquote'],
						['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
						['fontColor', 'hiliteColor', 'textStyle'],
						['removeFormat'],
						['outdent', 'indent'],
						['align', 'horizontalRule', 'list', 'lineHeight'],
						['table', 'link', 'image', 'video', 'audio'], 
						['fullScreen', 'showBlocks', 'codeView'],
					],
				}}
				onChange={onChange}
			/>

			<Modal
				title="Gallery"
				centered
				visible={showPhotoMaldal}
				onCancel={() => setShowPhotoModal(false)}
				width="1500px"
				destroyOnClose
				footer={null}>
				<ManagePhotoPage isNotModal={false} isHtmlModal={true} />
			</Modal>

			<Modal
				title="Gallery"
				centered
				visible={showVideoMaldal}
				onCancel={() => setShowVideoModal(false)}
				width="1500px"
				destroyOnClose
				footer={null}>
				<ManageVideoPage isNotModal={false} isHtmlModal={true} />
			</Modal>

			<Modal
				title="Gallery"
				centered
				visible={showDocumentMaldal}
				onCancel={() => setShowDocumentModal(false)}
				width="1500px"
				destroyOnClose
				footer={null}>
				<ManageDocumentPage isNotModal={false} isHtmlModal={true} />
			</Modal>
		</div>
	);
};

export default HtmlEditor;